import ng from 'angular';
import { StaffConst } from '@/configuration';
import { AuthContextService, GetEntryPointService } from '@/services';

import './supporter-block.scss';

export class MoleculeSupporterBlockController implements ng.IController {
    public static $inject: string[] = ['getEntryPoint', '$translate'];

    public backgroundSize: 'sm';
    public skipAuthCheck = false; // for account activation netim -> hosting
    public supportPhone: string;
    public supportPhoneMin ='';
    public supportMail: string;
    public staff: {name: string; title: string} = {
        name: StaffConst.kahrs.name,
        title: StaffConst.kahrs.title
    };

    constructor(
        private getEntryPointService: GetEntryPointService,
        private $translate: ng.translate.ITranslateService,
    ) {
    }

    // Call getEntryPoint
    public $onInit(): void {
        this.supportPhone = this.skipAuthCheck ? '' : AuthContextService.accountOrganizationInformation.companyPhoneNumber;
        if(this.skipAuthCheck) {
            if (this.getEntryPointService.domain === 'hosting.fr') {
                this.supportMail = 'info@hosting.fr';
            } else {
                this.supportMail = 'info@hosting.de';
            }
        } else {
            this.supportMail = AuthContextService.accountOrganizationInformation.companyEmailAddress;
        }
        this.supportPhoneMin = this.supportPhone.replace(/([() _-])/ig, '');
    }

    public get openingTimes(): string {
        return this.$translate.instant(
            'TR_130525-ae2a9d_TR',
            {
                startTime: this.getEntryPointService.supportStartTime,
                endTime: this.getEntryPointService.supportEndTime
            }
        );
    }

    public get hasPhoneNumber() {
        return this.supportPhone.length > 0;
    }
}

export class MoleculeSupporterBlockComponent implements ng.IComponentOptions {
    public bindings = {
        backgroundSize: '@?',
        skipAuthCheck: '<?',
    };
    public controller =  MoleculeSupporterBlockController;
    public template = require('./supporter-block.html');
}
